import { channelSearchConstants, commonConstants } from '../constants';
import myFetchWithId from '.././helpers/myFetch';
import {seriesMaker,timestampConverter,removeDuplicates,sumValueByProps,carryNumber,buildNodeAndRealtion,findKey,numberWithCommas,gatherData} from '../components/channelSearch/channelHelper';
import { getRangeDateList,timestampTOstringDate } from '../helpers/calDate';


const engReplace = {Negative:'負向',Neutral:'中立',Positive:'正向'}
const sentimentColor = {Negative:'#DA4453',Neutral:'#5D9CEC',Positive:'#37BC9B'}

// Universal function
export function cs_getDay(sDate,eDate,channel){
    return{
        type:channelSearchConstants.GET_DAY,
        sDate:sDate,
        eDate:eDate,
        channel:channel,
    }
}

export function cs_toAuthorDetail(name,channel,sdate,edate){
    let param= {
        author_name:name,
        author_channel:channel,
        sdate:sdate,
        edate:edate,
    }
    return dispatch => {
        dispatch(requestAuthorDetail())
        return myFetchWithId('', true, true)('/v5/lowi3/s/channels_data',param)
        .then(json => dispatch(receiveAuthorDetail(json)))
        .catch(err => {console.log(err)})
    };
}

function requestAuthorDetail (){
    return{
        type:channelSearchConstants.REQUEST_AUTHOR_DETAIL,
        receivedAt: Date.now(),
    }
}

function receiveAuthorDetail(json) {
    return{
        type:channelSearchConstants.RECEIVE_AUTHOR_DETAIL,
        value:json.values,
        receivedAt: Date.now(),
    }
}


// youtuber search function
export function cs_fetchYoutuber(name,sdate,edate){
    return dispatch => {
        dispatch(requestYoutuberSearch())
        return myFetchWithId('', true, true)('/v5/youtuber/search_youtuber', {kwd:name})
        .then(json => dispatch(receiveYouruberSearch(json,sdate,edate)))
        .catch(err => {console.log(err)})
      };
}

function requestYoutuberSearch (){
    return{
        type:channelSearchConstants.REQUEST_YT_SEARCH,
        receivedAt: Date.now(),
    }
}

function receiveYouruberSearch(json,sdate,edate){
    return{
        type:channelSearchConstants.RECEIVE_YT_SEARCH,
        sdate:sdate,
        edate:edate,
        searchData:json.data,
        totalPage: Math.ceil(json.data.length/20),
        receivedAt: Date.now(),
    }
}
export function cs_getCommentByDate(channel_id,sdate,edate) {
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_channel_sentiment_by_date',param)
        .then(json => dispatch(receiveCommentByDate(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveCommentByDate(json) {
    let commentData = Object.values(engReplace).map(item=>{
        return {
            name:item,
            // pointStart: this.props.detailData[0][0],
            color:sentimentColor[findKey(engReplace,item)],
            pointInterval: 24 * 3600 * 1000,
            data:[]
        }
    })

    json.data.forEach(item=>{
        commentData.forEach((obj,index)=>{
            if(engReplace[item.sentiment] === obj.name){
                commentData[index].data.push({
                    x:timestampConverter(item.date),
                    y:item.count,
                })
            }
        })
    })
    return{
        type:channelSearchConstants.RECEIVE_YT_COMMENT,
        commentData : commentData,
        receivedAt: Date.now(),
    }
}

export function cs_toYoutuberDetail(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_channel',param)
        .then(json => dispatch(receiveYoutuberDetail(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveYoutuberDetail(json) {
    return{
        type:channelSearchConstants.RECEIVE_YT_DETAIL,
        DetailDate: json.data,
        viewData : seriesMaker('view_count',json.data),
        subscribeData : seriesMaker('subscriber_count',json.data),
        receivedAt: Date.now(),
    }
}

export function cs_getYoutuberSentiment(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_channel_sentiment_overview',param)
        .then(json => dispatch(receiveYoutuberSentiment(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveYoutuberSentiment(json) {
    let total =  json.data.length>0 ? json.data.map(item=>item.count).reduce((acc,curr)=> {return acc+curr}) : 1
    let sentiment = json.data.map(item=>{
        return{
            'name':engReplace[item.sentiment]+` (${(item.count/total*100).toFixed(2)}%)`,
            'y':item.count ,
            'color':sentimentColor[item.sentiment],
        }
    })
    return{
        type:channelSearchConstants.RECEIVE_YT_SENTIMENT,
        sentiment: json.data.length>0 ? sentiment : [],
        receivedAt: Date.now(),
    }
}

export function cs_getFansActivity(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fans_activity',param)
        .then(json => dispatch(receiveFansActivity(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveFansActivity(json) {
    let data = gatherData(json.data)

    let fansActiveData = data.map(item=>{
        let day =  timestampConverter(item.ymd)
        let hour = parseInt(item.doh,10)
        let comment = item.count
        let timelabel = item.ymd.substring(0,4)+'-'+item.ymd.substring(4,6)+'-'+item.ymd.substring(6,8)
        return {x:day,y:hour,z:comment,time:timelabel,name:'something'}
    })
    return{
        type:channelSearchConstants.RECEIVE_FANS_ACTIVITY,
        fansActiveData: fansActiveData,
        receivedAt: Date.now(),
    }
}

export function cs_getFansPath(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
        top_n:500,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fans_path',param)
        .then(json => dispatch(receiveFansPath(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveFansPath(json) {
    const {nodeData,edgeData,nodeStyle} = buildNodeAndRealtion(json.data)
    
    return{
        type:channelSearchConstants.RECEIVE_FANS_PATH,
        nodesData: nodeData,
        edgesData: edgeData,
        groupsData: nodeStyle,
        receivedAt: Date.now(),
    }
}

export function cs_getFansList(channel_id,sdate,edate,top_n){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
        top_n:top_n,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fans',param)
        .then(json => dispatch(receiveFansList(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveFansList(json) {
    return{
        type:channelSearchConstants.RECEIVE_FANS_LIST,
        fansData: json.data,
        receivedAt: Date.now(),
    }
}

export function cs_getFansComment(channel_id,sdate,edate,author_id,sentiment){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
        author_id:author_id,
        vibe_sentiment:sentiment,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fans_comments',param)
        .then(json => dispatch(receiveFansComment(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveFansComment(json) {
    if(json.response_status ==='SUCCESS'){
        const commentList = json.data.map(item=>{
            let comment = {
                video_id : item.video_id,
                comment_id : item.comment_id,
                comment_text : item.comment_text,
                fans_name : item.author_name,
                fans_id : item.author_id,
                like_count : item.like_count,
                reply_count : item.reply_count,
                published_time : item.published_at.substring(0,4)+'-'+item.published_at.substring(4,6)+'-'+item.published_at.substring(6,8)+item.published_at.substring(8,17),
                update_time : item.updated_at,
                vibe_sentiment : item.vibe_sentiment,
                positive_total_score : item.positive_total_score,
                negative_total_score : item.negative_total_score,
            }
            return comment
        })
        const video = json.data.map(item=>{
            let comments = []

            commentList.forEach(comment=>{
                if(comment.video_id === item.video_id){
                    comments.push(comment)
                }
            })
    
            let video = {
                video_id:item.video_id,
                video_title:item.video_title,
                video_description:item.video_description,
                video_dislike_count:carryNumber(item.video_dislike_count),
                video_favorite_count:carryNumber(item.video_favorite_count),
                video_like_count:carryNumber(item.video_like_count),
                video_published_at:item.video_published_at.substring(0,4)+'-'+item.video_published_at.substring(4,6)+'-'+item.video_published_at.substring(6,8)+item.video_published_at.substring(8,17),
                video_view_count:carryNumber(item.video_view_count),
                video_comment_count:carryNumber(item.video_comment_count),
                comments:comments
            }
            return video
        })

        const videoList = removeDuplicates(video,'video_id')

        return{
            type:channelSearchConstants.RECEIVE_FANS_COMMENT,
            videoList:videoList,
            receivedAt: Date.now(),
        }
    }else{
        return{
            type:channelSearchConstants.RECEIVE_FANS_COMMENT,
            videoList:[],
            receivedAt: Date.now(),
        }
    }
}

export function cs_getCommentSentiment(channel,sdate,edate,author_id){
    let param= {
        start_date:sdate,
        end_date:edate,
        author_id:author_id,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fan_comment_sentiment',param)
        .then(json => dispatch(receiveCommentSentiment(json,channel)))
        .catch(err => {console.log(err)})
    };
}

function receiveCommentSentiment(json,channel) {
    const channel_id = channel.channel_id
    const channelData = []
    const sentimentData = []
    let thisChannel = json.data.filter(item => item.channel_id === channel_id )
    let othreChannel = json.data.filter(item => item.channel_id !== channel_id )
    
    if(thisChannel.length>0){
        channelData.push({
            id:channel_id,
            name:channel.channel_title,
            y:thisChannel.map(item=>item.c).reduce((acc,curr)=>acc+curr)
        })
        let tag = thisChannel.map(item=>{
            return{
                parent:item.channel_id,
                name:engReplace[item.vibe_sentiment],
                y:item.c,
                color:sentimentColor[item.vibe_sentiment],
                visible:item.visible !== undefined ? item.visible :true,
            }
        })
        
        sentimentData.push(...tag)
    }else if(othreChannel.length > 0){
        // 暫時先不考慮該留言者在其他頻道的留言
        const otherID = [...new Set(othreChannel.map(item=>item.channel_id))].join('+')

        // channelData.push({
        //     id:otherID,
        //     name:'其他頻道',
        //     y:othreChannel.map(item=>item.c).reduce((acc,curr)=>acc+curr)
        // })

        let sentimentSUM = sumValueByProps(othreChannel,'c','vibe_sentiment')
        let tag = Object.keys(sentimentSUM).map(item=>{
            return{
                parent:'other_channel',
                name:`other_channel - ${engReplace[item]}`,
                y:sentimentSUM[item],
                color:sentimentColor[item],
                visible:item.visible !== undefined ? item.visible :true,
            }
        })

        // sentimentData.push(...tag)
    }

    return{
        type:channelSearchConstants.RECEIVE_COMMENT_SENTIMENT,
        channelData: channelData,
        sentimentData: sentimentData, 
        receivedAt: Date.now(),
    }
}

export function cs_getCommentTimeList(channel_id,sdate,edate,author_id){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
        author_id:author_id,
        // format:'YYYYMMDD'
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_fan_comment_time',param)
        .then(json => dispatch(receiveCommentTimeList(json,sdate,edate)))
        .catch(err => {console.log(err)})
    };
}

function receiveCommentTimeList(json,sdate,edate) {
    let days = getRangeDateList(sdate,edate)

    let timeList = days.map(day=>{
        let y = 0
        json.data.forEach(item => {
            let timelabel = item.d.substring(0,4)+'-'+item.d.substring(4,6)+'-'+item.d.substring(6,8)
            if(timelabel===timestampTOstringDate(day)){
                y = item.c
            }
        });
        return {x:day,y:y,time:timestampTOstringDate(day)}
    })
    

    return{
        type:channelSearchConstants.RECEIVE_COMMENT_TIME,
        timeList: [{name:'留言時間線圖',data:timeList}],
        receivedAt: Date.now(),
    }
}

export function cs_getVideos(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_videos',param)
        .then(json => dispatch(receiveVideos(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideos(json) {
    let videoList = json.data.map(item=>{
        return {
            ...item,
            published_at_label:item.published_at.substring(0,10),
            last_time_label:item.last_time.substring(0,10),
            view_label:carryNumber(item.view_count),
            like_label:carryNumber(item.like_count),
            comment_label:carryNumber(item.comment_count),
        }
    })
    return{
        type:channelSearchConstants.RECEIVE_VIDEOS,
        videoList: videoList,
        receivedAt: Date.now(),
    }
}

export function cs_getSingleVideo(channel_id,video_id){
    let param= {
        channel_id:channel_id,
        video_id:video_id,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_video',param)
        .then(json => dispatch(receiveSingleVideo(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveSingleVideo(json) {
    return{
        type:channelSearchConstants.RECEIVE_VIDEO,
        timeList: json.data,
        receivedAt: Date.now(),
    }
}

export function cs_getVideoSentiment(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_videos_sentiment_overview',param)
        .then(json => dispatch(receiveVideoSentiment(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideoSentiment(json) {
    const groupCountByID = sumValueByProps(json.data,'c','video_id')

    let tagCountsData = json.data.map(item =>{
        return{
            parentId:item.video_id,
            name:engReplace[item.vibe_sentiment]+'-'+item.title,
            y:item.c,
            color:sentimentColor[item.vibe_sentiment],
            visible:item.visible !== undefined ? item.visible :true,
        }
    })

    let keywordsData = json.data.map((item) =>{
        return{
            id:item.video_id,
            name:item.title,
            y:groupCountByID[item.video_id],
        }
    })
    
    keywordsData = removeDuplicates(keywordsData,'id')
    
    return{
        type:channelSearchConstants.RECEIVE_VIDEO_SENTIMENT,
        videoSentimentData: json.data,
        keywordsData: keywordsData,
        tagCountsData: tagCountsData,
        receivedAt: Date.now(),
    }
}

export function cs_getVideoActivity(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_videos_activity',param)
        .then(json => dispatch(receiveVideoActivity(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideoActivity(json) {
    let videoActiveData = json.data.map(item=>{
        let day =  timestampConverter(item.ymd)
        let view_count = item.view_count
        let comment = item.comment_count
        let timelabel = item.ymd.substring(0,4)+'-'+item.ymd.substring(4,6)+'-'+item.ymd.substring(6,8)
        let video_name = item.title
        return {x:day,y:view_count,z:comment,time:timelabel,name:video_name}
    })

    return{
        type:channelSearchConstants.RECEIVE_VIDEO_ACTIVITY,
        videoActiveData: videoActiveData,
        receivedAt: Date.now(),
    }
}

export function cs_getVideoComments(video_id){

    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_video_comments',{video_id:video_id})
        .then(json => dispatch(receiveVideoComments(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideoComments(json) {
    return{
        type:channelSearchConstants.RECEIVE_VIDEO_COMMENTS,
        timeList: json.data,
        receivedAt: Date.now(),
    }
}

export function cs_getVideoStatus(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_videos_status',param)
        .then(json => dispatch(receiveVideoStatus(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideoStatus(json) {
    const translate ={'view':'觀看','like':'按讚','dislike':'不喜歡','favorite':'珍藏','comment':'留言'}
    let toArray = Object.values(json.data[0]).map((val,index)=>{
        return {
            name:Object.keys(json.data[0])[index],
            value:numberWithCommas(parseInt(val))
        }
    })
    let statusList = [...new Set(Object.keys(json.data[0]).map(item=>{return item.split('_')[1]}))].map(item=>{
        let keyItem = {name:translate[item]}
        toArray.forEach(obj=>{
            if(obj.name.split('_')[1] === item){
                if(obj.name.split('_')[0] === 'avg') keyItem['avg']=obj.value
                else keyItem['sum']=obj.value
            }
        })
        return keyItem
    })
    return{
        type:channelSearchConstants.RECEIVE_VIDEO_STATUS,
        videoStatus: statusList,
        receivedAt: Date.now(),
    }
}

export function cs_getVideoPopComment(channel_id,sdate,edate){
    let param= {
        channel_id:channel_id,
        start_date:sdate,
        end_date:edate,
    }
    return dispatch => {
        return myFetchWithId('', true, true)('/v5/youtuber/youtube_videos_terms',param)
        .then(json => dispatch(receiveVideoPopComment(json)))
        .catch(err => {console.log(err)})
    };
}

function receiveVideoPopComment(json) {
    if(json.response_status === "SUCCESS" ){
        let commentList = json.data.map(item=>{return{name:item.value,weight:item.weight}});
        return{
            type:channelSearchConstants.RECEIVE_VIDEO_TERMS,
            commentList: commentList,
            receivedAt: Date.now(),
        }
    }else{
        return{
            type:channelSearchConstants.RECEIVE_VIDEO_TERMS,
            commentList: [],
            receivedAt: Date.now(),
        }
    }
}

// facebook search function
export function cs_fetchFacebook(name,sdate,edate){
    return dispatch => {
        dispatch(requestFacebookSearch())
        return myFetchWithId('', true, true)('/v5/youtuber/search_youtuber', {kwd:name})
        .then(json => dispatch(receiveFacebookSearch(json,sdate,edate)))
        .catch(err => {console.log(err)})
      };
}

function requestFacebookSearch (){
    return{
        type:channelSearchConstants.REQUEST_FB_SEARCH,
        receivedAt: Date.now(),
    }
}

function receiveFacebookSearch(json,sdate,edate){
    return{
        type:channelSearchConstants.RECEIVE_FB_SEARCH,
        sdate:sdate,
        edate:edate,
        searchData:json.data,
        totalPage: Math.ceil(json.data.length/20),
        receivedAt: Date.now(),
    }
}



// WEBPACK FOOTER //
// ./src/actions/channelSearch.action.js